/**
 * THE 404'S WORDS, written once (PV5-8:A, design-system §7b).
 *
 * What a visitor reads at an address the app has no page for: src/App.tsx's catch-all route (`*`). Today's page
 * (src/pages/NotFound.tsx) and its rebuild in the new design (src/design/pavilion/pages/not-found/) both read them, so
 * the two cannot drift: a rebuild changes how a page looks, never what it says.
 *
 * They are prest0.ai's words, kept exactly as written. Today's page shows "Return to Home" lowercased by its own inline
 * style (`textTransform: 'lowercase'`); the rebuild shows it the same way with CSS (its sheet's TODAY'S CASE block),
 * never by rewriting it here.
 */

const LINE = "The page you're looking for doesn't exist or has been moved.";

export const NOT_FOUND_WORDS = {
  /** The page's title. */
  title: '404',
  /** The one line under it. */
  line: LINE,
  /** The one action: back to the home page. */
  home: 'Return to Home',
  /**
   * What both pages hand <SeoHead> with `noIndex` (2026-10-11, the one change on prest0.ai): a tab title instead of the
   * site's default, and search engines kept away from an address that has no page (an address that leads nowhere a
   * search should send anyone, as the email-link and invitation pages' heads say). Its description is the line itself.
   */
  seo: {
    tabTitle: 'page not found',
    title: 'Page Not Found | prest0',
    description: LINE,
  },
} as const;
